export const CREATE_ROSTER = "CREATE_ROSTER";
export const FETCH_ROSTERS = "FETCH_ROSTERS";
export const FETCH_ROSTER = "FETCH_ROSTER";
export const CLEAR_ROSTER = "CLEAR_ROSTER";
export const EDIT_ROSTER = "EDIT_ROSTER";
export const DELETE_ROSTER = "DELETE_ROSTER";
